module.exports = __webpack_public_path__ + "img/lithotherapie-bioenergetique-des-espaces.e52c82c0.jpg";